import {
  StaleBranchesClient,
  ClientOutput,
} from '../../Clients/StaleBranchesClient';
import { call, put } from 'redux-saga/effects';
import { ApiGetter } from '../../Clients/ApiGetter';
import { actions } from '../../../reducers/ProjectDashboard/StaleBranches';

export const staleBranchesClient = new StaleBranchesClient(new ApiGetter());

interface GetStaleBranchesAction {
  repositoryUUID: string;
}

export function* getStaleBranches({ repositoryUUID }: GetStaleBranchesAction) {
  const { data, error }: ClientOutput = yield call(
    [staleBranchesClient, staleBranchesClient.retrieveAsync],
    repositoryUUID
  );

  if (error || !data) {
    yield put(actions.setStaleBranches(undefined));
    return;
  }

  yield put(actions.setStaleBranches(data));
}
